import AttachFileIcon from "@mui/icons-material/AttachFile";
import Box, { BoxProps } from "@mui/material/Box";
import { openLightbox } from "csi/service/lightboxService";
import { useStore } from "csi/state/hooks";
import { cnl, IFileData } from "csi/typings";
import React, { FunctionComponent, MouseEvent, useState } from "react";
import { preventDefaultBehaviour } from "designSystem/utilities/prevent-default-behavior";
import { Button } from "designSystem/index";
import FilesPopover from "designSystem/components/file/FilesPopover";

interface AttachmentGroupButtonProps extends BoxProps {
	commentUrl: cnl;
}

const AttachmentGroupButton: FunctionComponent<AttachmentGroupButtonProps> = (props) => {
	const { commentsStore } = useStore();
	const { cache, getAllCommentAttachments } = commentsStore;
	const { commentUrl, ...otherProps } = props;
	const [showAttachments, setShowAttachments] = useState(false);
	const [attachments, setAttachments] = useState(null);
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

	/** open the popup */
	const handleClick = async (event: MouseEvent<HTMLElement>) => {
		preventDefaultBehaviour(event);
		setAnchorEl(event.currentTarget);
		if (!attachments) {
			setAttachments(await getAllCommentAttachments(commentUrl));
		}
		setShowAttachments(true);
	};

	/** Close the popup */
	const handleClose = (event: MouseEvent<HTMLElement>) => {
		preventDefaultBehaviour(event);
		setAnchorEl(null);
		onCloseAttachments();
	};

	const onClickImage = (fileData: IFileData) => {
		const imageNode = cache.get(fileData.imageUrl);
		onCloseAttachments();
		openLightbox(imageNode, cache, true);
	};

	const onCloseAttachments = () => {
		setShowAttachments(false);
	};

	return (
		<Box {...otherProps}>
			<Button
				design="defaultOnGrey"
				onClick={handleClick}
				startIcon={<AttachFileIcon />}
			/>
			<FilesPopover
				anchorEl={anchorEl}
				files={attachments || []}
				onClose={handleClose}
				onImage={onClickImage}
				open={showAttachments}
			/>
		</Box>
	);
};

export default AttachmentGroupButton;
